import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RefundItemsFormDataBuilderInterface } from './interface/form-data.builder.interface';
import { RefundFormComponent } from '../refund-form.component';

@Component({
  template: ''
})
export abstract class RefundItemsFormComponent extends RefundFormComponent implements OnInit {
  _formValues: RefundItemsFormDataBuilderInterface;
  @Input() set formValues(model: RefundItemsFormDataBuilderInterface) {
    this._formValues = model;

    if (this.refundForm) {
      this.refundForm.setValue({
        bookingId: model.bookingNo || '',
        email: model.email || ''
      });
      this.refundForm.updateValueAndValidity();
    }
  }

  getFrom(): FormGroup {
    return this.getFormGroup({ ...this._formValues });
  }

  abstract getFormGroup(formDataBuilderInterface: RefundItemsFormDataBuilderInterface): FormGroup;
}
